// extracted by mini-css-extract-plugin
export default {"paymentSection":"d--z"};